/**
=========================================================
* Iris Design Limited  Fulfilment POD - v2.2.0
=========================================================

* Product Page: https://www.irisdesignlimited.com/product/material-dashboard-react
* Copyright 2023 Dev Iris Design Limited Company (https://www.irisdesignlimited.com)

Coded by www.irisdesignlimited.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Iris Design Limited  Fulfilment POD base styles
import borders from "assets/theme/base/borders";
import boxShadows from "assets/theme/base/boxShadows";

const { borderRadius } = borders;
const { xxl } = boxShadows;

const dialog = {
  styleOverrides: {
    paper: {
      borderRadius: borderRadius.xxl,
      boxShadow: xxl,
    },

    paperFullScreen: {
      borderRadius: 0,
    },
  },
};

export default dialog;
